<div class="profile-content">
  <div class="row">
    <div class="col-md-12">
      <div class="caption caption-md">
        <span class="caption-subject">Change Profile image</span>
      </div>
    </div>
    <div>
      <form [formGroup]="changeImageForm">
        <br />
        <div class="form-group">
          <div class="profile-image">
            <span class="btn default btn-file">
              <input
                type="file"
                (change)="fileChangeEvent($event)"
                style="display: none"
                #hiddenfileinput
              />
              <button
                style="padding: 0px; color: white"
                (click)="hiddenfileinput.click()"
                class="waves-effect waves-light btn"
              >
                Select image
              </button>
            </span>
            <div class="cropImage" style="width: 600px; height: 600px; margin-top: 20px">
              <image-cropper
                [imageURL]="imgsrc"
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="4 / 4"
                [transform]="transform"
                [style.display]="showCropper ? null : 'none'"
                mouseWheel
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                [hideResizeSquares]="false"
                [cropper]="cropper"
                (mouseWheelUp)="zoomIn($event)"
                (mouseWheelDown)="zoomOut($event)"
              ></image-cropper>
            </div>
            <!-- [cropper] ="coordinates" -->
          </div>
        </div>
        <div style="margin-top: 10px">
          <button type="button" (click)="submit()" class="btn blue-hoki btn-save submitButton">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
